import {
  ChildrenDocumentAttachment,
  ChildrenDocumentMissing,
  DOCUMENT_STATUS_CONFIG,
  DocumentStatus,
} from '../../models/document'
import { Pill } from '../Pill/Pill'

interface DocumentRowInfoStatusProps {
  item: ChildrenDocumentMissing | ChildrenDocumentAttachment | null
}

export function DocumentRowInfoStatus({ item }: DocumentRowInfoStatusProps) {
  if (item && 'status' in item) {
    if (item?.status === DocumentStatus.VALID) {
      return <img src={DOCUMENT_STATUS_CONFIG[item?.status].icon} width="24px" alt="" />
    }

    return (
      <Pill
        color={DOCUMENT_STATUS_CONFIG[item?.status].color}
        background={DOCUMENT_STATUS_CONFIG[item?.status].backgroundColor}
      >
        {DOCUMENT_STATUS_CONFIG[item?.status].value}
      </Pill>
    )
  }

  return (
    <Pill
      color={DOCUMENT_STATUS_CONFIG.NOT_UPLOADED.color}
      background={DOCUMENT_STATUS_CONFIG.NOT_UPLOADED.backgroundColor}
    >
      {DOCUMENT_STATUS_CONFIG.NOT_UPLOADED.value}
    </Pill>
  )
}
